<script setup lang="ts">
// const props = withDefaults(defineProps<{ name: string; avatar?: string }>(), {
//   avatar: '',
// });

// https://orthodgt.pockethost.io/api/files/_pb_users_auth_/xv9blnxzmjfs7tx

const dataStore = useDataStore();
const user = computed(() => dataStore.user);

const initials = computed(() => user.value?.name.split(' ').map(n => n[0]).filter((_, i) => i < 2).join('').toUpperCase() || '');

const avatarImg = computed(() => {
  if (!user.value?.avatar) {
    return '';
  }
  return `${user.value?.id}/${user.value?.avatar}`;
});
</script>

<template>
  <div class=" w-[44px] h-[44px] rounded-full bg-gray-300 border-gray-100 hover:border-gray-500 flex items-center justify-center border overflow-hidden shadow-inner-border">
    <div class="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center">
      <NuxtImg
        v-if="avatarImg"
        format="webp"
        provider="pocketbase"
        :src="avatarImg"
        class="h-full"
        alt="avatar"
      />
      <div
        v-else
        class="text-sub text-gray-800"
      >
        {{ initials }}
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
